(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Collapsibles_id"] && !Shopify.designMode) return;
  try {
    
  const collapsibles = document.querySelectorAll('.collapsible_img');
  const contents = document.querySelectorAll('.content_mj');

  collapsibles.forEach((collapsible, index) => {
    collapsible.addEventListener('click', function () {
      // Close all other sections
      contents.forEach((content, i) => {
        if (i !== index) {
          content.style.display = 'none';
          collapsibles[i].classList.remove('active');
        }
      });

      // Toggle the clicked section
      const content = this.nextElementSibling;
      if (content.style.display === 'block') {
        content.style.display = 'none';
        this.classList.remove('active');
      } else {
        content.style.display = 'block';
        this.classList.add('active');
      }
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collapsible_mj"] && !Shopify.designMode) return;
  try {
    
   document.addEventListener('DOMContentLoaded', function () {
    const collapsibleContainers = document.querySelectorAll('.collapsible-container');
    
    collapsibleContainers.forEach((button) => {
        const content = button.nextElementSibling; // The content is the next sibling of the button
        const arrowIcon = button.querySelector('.arrow-icon');

        button.addEventListener('click', () => {
            if (content.style.display === 'none' || content.style.display === '') {
                content.style.display = 'block';
                arrowIcon.style.transform = 'rotate(180deg)'; // Rotate the arrow
            } else {
                content.style.display = 'none';
                arrowIcon.style.transform = 'rotate(0deg)'; // Reset the arrow
            }
        });
    });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["points_check"] && !Shopify.designMode) return;
  try {
    
let phoneNumber = ''; // Variable to store phone number for verification

document.getElementById('send-otp').addEventListener('click', function(event) {
    event.preventDefault();
    
    // Clear previous messages
    document.getElementById('send-response-message').innerHTML = '';
    document.getElementById('submit-response-message').innerHTML = '';

    phoneNumber = document.getElementById('phone_number').value;
    const name = document.getElementById('name').value;

    if (!phoneNumber || !name) {
        alert("Please fill in all fields.");
        return;
    }

    const data = new URLSearchParams();
    data.append('phone_number', phoneNumber);
    data.append('name', name);

    fetch('https://team.montecarlo.in/mc_data/unicom/online/products/data/otp_sms.php', {
        method: 'POST',
        body: data,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        }
    })
    .then(response => response.text())
    .then(data => {
        document.getElementById('send-response-message').innerHTML = "OTP sent successfully!";
        document.getElementById('full_form_id').style.display = 'none';
        document.getElementById('otp-input').style.display = 'block';
    })
    .catch(error => {
        console.error('Error:', error);
        document.getElementById('send-response-message').innerHTML = "Failed to send OTP. Please try again.";
    });
});

document.getElementById('submit-otp').addEventListener('click', function(event) {
    event.preventDefault();

    // Clear previous response messages
    document.getElementById('submit-response-message').innerHTML = '';

    const otp = document.getElementById('otp').value;

    if (!otp) {
        alert("Please enter the OTP.");
        return;
    }

    // Send OTP and phone number for verification
    fetch('https://team.montecarlo.in/mc_data/unicom/online/products/data/verify_otp.php', {
        method: 'POST',
        body: new URLSearchParams({
            'phone_number': phoneNumber,
            'otp': otp
        }),
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        }
    })
    .then(response => response.text())
    .then(data => {
        if (data.trim() === "success") {
            document.getElementById('submit-response-message').innerHTML = "OTP Verified Successfully!";
        } else {
            document.getElementById('submit-response-message').innerHTML = "Incorrect OTP. Please try again.";
        }
        document.getElementById('otp').value = ''; // Clear OTP input after submission
    })
    .catch(error => {
        console.error('Error:', error);
        document.getElementById('submit-response-message').innerHTML = "Error verifying OTP.";
    });
});
// Function to fetch Salesforce data and display it in the table
    function fetchSalesforceData() {
        fetch('https://team.montecarlo.in/mc_data/unicom/online/products/data/fetch-salesforce-data.php')  // Ensure this is the correct path to your PHP script
        .then(response => response.json())
        .then(data => {
            if (data.memberTier && data.points) {
                let tableBody = document.querySelector('#salesforce-data-table tbody');
                let row = document.createElement('tr');
                row.innerHTML = `
                    <td>${data.phone}</td>
                    <td>${data.memberTier}</td>
                    <td>${data.points}</td>
                    <td>${JSON.stringify(data)}</td>
                `;
                tableBody.appendChild(row);
            } else {
                alert('No data found for this phone number.');
            }
        })
        .catch(error => console.error('Error fetching Salesforce data:', error));
    }

    // Fetch and display the data when the page loads
    window.onload = fetchSalesforceData;

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["return_panel"] && !Shopify.designMode) return;
  try {
    
  const orderInput = document.querySelector('.order');

  // Convert input to uppercase while typing
  orderInput.addEventListener('input', function () {
    this.value = this.value.toUpperCase();
  });

  document.getElementById('returnForm').addEventListener('submit', function(e) {
    e.preventDefault();

    const contactInput = document.querySelector('.contact');
    const orderNumber = orderInput.value.trim();
    const contact = contactInput.value.trim();

    let isValid = true;

    // Clear previous errors
    document.getElementById('orderError').textContent = '';
    document.getElementById('contactError').textContent = '';
    orderInput.classList.remove('error-field');
    contactInput.classList.remove('error-field');

    // Validate Order Number (at least 6 alphanumeric characters)
    if (!/^[a-zA-Z0-9]{6,}$/.test(orderNumber)) {
      document.getElementById('orderError').textContent = 'Order number must be at least 6 alphanumeric characters.';
      orderInput.classList.add('error-field');
      isValid = false;
    }

    // Validate Contact (either email or Indian phone)
    let isEmail = false;
    let isPhone = false;
    if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(contact)) {
      isEmail = true;
    } else if (/^[6-9]\d{9}$/.test(contact)) {
      isPhone = true;
    } else {
      document.getElementById('contactError').textContent = 'Enter a valid email address or 10-digit Indian phone number.';
      contactInput.classList.add('error-field');
      isValid = false;
    }

    if (!isValid) return;

    // Build the iframe URL
    let iframeSrc = `https://montecarlo.clickpost.ai/returns?order_id=${encodeURIComponent(orderNumber)}&app_only=true`;
    if (isEmail) {
      iframeSrc += `&email=${encodeURIComponent(contact)}`;
    } else if (isPhone) {
      iframeSrc += `&mobile=${encodeURIComponent(contact)}`;
    }

    document.getElementById('returnFrame').src = iframeSrc;
    document.getElementById('returnForm').style.display = 'none';
    document.getElementById('returnFrame').style.display = 'block';
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["return_track"] && !Shopify.designMode) return;
  try {
    
  const orderInput = document.querySelector('.order');

  // Convert input to uppercase while typing
  orderInput.addEventListener('input', function () {
    this.value = this.value.toUpperCase();
  });

  document.getElementById('returnForm').addEventListener('submit', function(e) {
    e.preventDefault();

    const contactInput = document.querySelector('.contact');
    const orderNumber = orderInput.value.trim();
    const contact = contactInput.value.trim();

    let isValid = true;

    // Clear previous errors
    document.getElementById('orderError').textContent = '';
    document.getElementById('contactError').textContent = '';
    orderInput.classList.remove('error-field');
    contactInput.classList.remove('error-field');

    // Validate Order Number (at least 6 alphanumeric characters)
    if (!/^[a-zA-Z0-9]{6,}$/.test(orderNumber)) {
      document.getElementById('orderError').textContent = 'Order number must be at least 6 alphanumeric characters.';
      orderInput.classList.add('error-field');
      isValid = false;
    }

    // Validate Contact (either email or Indian phone)
    let isEmail = false;
    let isPhone = false;
    if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(contact)) {
      isEmail = true;
    } else if (/^[6-9]\d{9}$/.test(contact)) {
      isPhone = true;
    } else {
      document.getElementById('contactError').textContent = 'Enter a valid email address or 10-digit Indian phone number.';
      contactInput.classList.add('error-field');
      isValid = false;
    }

    if (!isValid) return;

    // Build the iframe URL
    let iframeSrc = `https://montecarlo.clickpost.ai/returns?order_id=${encodeURIComponent(orderNumber)}&app_only=true`;
    if (isEmail) {
      iframeSrc += `&email=${encodeURIComponent(contact)}`;
    } else if (isPhone) {
      iframeSrc += `&mobile=${encodeURIComponent(contact)}`;
    }

    document.getElementById('returnFrame').src = iframeSrc;
    document.getElementById('returnForm').style.display = 'none';
    document.getElementById('returnFrame').style.display = 'block';
  });

  } catch(e) { console.error(e); }
})();
})();
